{
    "v": "5.7.3",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 150.000006109625,
    "w": 500,
    "h": 500,
    "nm": "Analyse",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 2 :M",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 45,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        385.694,
                        214.262,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        265.23,
                        265.12,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.972,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.973
                                                ],
                                                [
                                                    -3.972,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.972
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.972,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.972
                                                ],
                                                [
                                                    3.972,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.973
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    -7.203
                                                ],
                                                [
                                                    -7.202,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    7.203
                                                ],
                                                [
                                                    7.203,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    4.674,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.674
                                                ],
                                                [
                                                    -4.675,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.675
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -4.675,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.675
                                                ],
                                                [
                                                    4.674,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.674
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    8.477
                                                ],
                                                [
                                                    -8.479,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    -8.477
                                                ],
                                                [
                                                    8.479,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.521,
                                            35.496
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 4,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    265.23,
                                    265.12
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    35.521,
                                    35.496
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 2",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    4.33
                                                ],
                                                [
                                                    -4.33,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.592
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -4.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.592
                                                ],
                                                [
                                                    -4.33,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.809,
                                                    0
                                                ],
                                                [
                                                    2.031,
                                                    -7.84
                                                ],
                                                [
                                                    5.809,
                                                    0
                                                ],
                                                [
                                                    2.031,
                                                    7.84
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.835294187069,
                                            0.309803932905,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            33.491,
                                            35.496
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    255.775,
                                    265.12
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    33.491,
                                    35.496
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 3",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    4.33
                                                ],
                                                [
                                                    -4.33,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.33
                                                ],
                                                [
                                                    4.33,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -4.33
                                                ],
                                                [
                                                    4.33,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.33
                                                ],
                                                [
                                                    -4.33,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.841,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -7.84
                                                ],
                                                [
                                                    7.841,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    7.84
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.937254965305,
                                            0.517647087574,
                                            0.129411771894,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.522,
                                            35.496
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 4",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    265.234,
                                    265.12
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    35.522,
                                    35.496
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 4",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 8 :M",
            "parent": 4,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 34,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 64,
                            "s": [
                                -40
                            ]
                        },
                        {
                            "t": 80.0000032584668,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        269.998,
                        269.887,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        385.695,
                        214.264,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.215,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.191,
                                                    2.863
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.063,
                                                    3.989
                                                ],
                                                [
                                                    5.557,
                                                    8.23
                                                ],
                                                [
                                                    6.063,
                                                    -8.8
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.137254908681,
                                            0.61960786581,
                                            0.796078443527,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 4')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.458,
                                            44.296
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 8",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    340.013,
                                    225.899
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    29.458,
                                    44.296
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 45,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 8",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.588
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.001,
                                                    -2.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.249,
                                                    3.625
                                                ],
                                                [
                                                    8.535,
                                                    -3.872
                                                ],
                                                [
                                                    -8.82,
                                                    -3.625
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.133333340287,
                                            0.61960786581,
                                            0.796078503132,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 5')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.342,
                                            39.121
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 11",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    404.549,
                                    251.236
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    44.342,
                                    39.121
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 45,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 111",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.221,
                                                    -3.453
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.094,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.99,
                                                    -2.626
                                                ],
                                                [
                                                    6.445,
                                                    8.821
                                                ],
                                                [
                                                    6.445,
                                                    -8.821
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.133333340287,
                                            0.61960786581,
                                            0.796078443527,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 6')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.077,
                                            26.676
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 13",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    389.139,
                                    164.009
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    29.077,
                                    26.676
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 45,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 113",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.439,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.21,
                                                    -0.966
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.39,
                                                    -8.013
                                                ],
                                                [
                                                    -5.497,
                                                    8.089
                                                ],
                                                [
                                                    5.497,
                                                    -5.693
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.133333340287,
                                            0.61960786581,
                                            0.796078503132,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 7')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            41.019,
                                            27.408
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 15",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    426.922,
                                    203.483
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    41.019,
                                    27.408
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 45,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 115",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            9.375,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -9.376
                                                        ],
                                                        [
                                                            -9.376,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            9.376
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -9.376,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            9.376
                                                        ],
                                                        [
                                                            9.375,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -9.376
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            0,
                                                            -17.004
                                                        ],
                                                        [
                                                            -17.004,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            17.004
                                                        ],
                                                        [
                                                            17.003,
                                                            0
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ind": 1,
                                            "ty": "sh",
                                            "ix": 2,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            10.078,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            10.078
                                                        ],
                                                        [
                                                            -10.078,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -10.078
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -10.078,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -10.078
                                                        ],
                                                        [
                                                            10.078,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            10.078
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            0,
                                                            18.277
                                                        ],
                                                        [
                                                            -18.278,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -18.277
                                                        ],
                                                        [
                                                            18.278,
                                                            0
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 2",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 1,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    35.522,
                                                    35.496
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 1",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            265.233,
                                            265.121
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            35.522,
                                            35.496
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 1",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.242,
                                                            0
                                                        ],
                                                        [
                                                            0.086,
                                                            0.039
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.145,
                                                            0.32
                                                        ],
                                                        [
                                                            -0.318,
                                                            -0.145
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.145,
                                                            -0.32
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.088,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.32,
                                                            -0.144
                                                        ],
                                                        [
                                                            0.144,
                                                            -0.323
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.321,
                                                            0.145
                                                        ],
                                                        [
                                                            -0.106,
                                                            0.236
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            8.035,
                                                            4.306
                                                        ],
                                                        [
                                                            7.772,
                                                            4.249
                                                        ],
                                                        [
                                                            -8.297,
                                                            -3.001
                                                        ],
                                                        [
                                                            -8.616,
                                                            -3.842
                                                        ],
                                                        [
                                                            -7.773,
                                                            -4.161
                                                        ],
                                                        [
                                                            8.297,
                                                            3.089
                                                        ],
                                                        [
                                                            8.616,
                                                            3.931
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    43.557,
                                                    39.078
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 5",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            302.641,
                                            281.999
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            43.557,
                                            39.122
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 5",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.168,
                                                            0
                                                        ],
                                                        [
                                                            0.123,
                                                            0.116
                                                        ],
                                                        [
                                                            -0.242,
                                                            0.255
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.254,
                                                            -0.24
                                                        ],
                                                        [
                                                            0.242,
                                                            -0.255
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.158,
                                                            0
                                                        ],
                                                        [
                                                            -0.256,
                                                            -0.242
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.243,
                                                            -0.255
                                                        ],
                                                        [
                                                            0.255,
                                                            0.243
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.125,
                                                            0.132
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            -6.063,
                                                            7.064
                                                        ],
                                                        [
                                                            -6.501,
                                                            6.891
                                                        ],
                                                        [
                                                            -6.526,
                                                            5.991
                                                        ],
                                                        [
                                                            5.601,
                                                            -6.799
                                                        ],
                                                        [
                                                            6.502,
                                                            -6.824
                                                        ],
                                                        [
                                                            6.526,
                                                            -5.923
                                                        ],
                                                        [
                                                            -5.601,
                                                            6.867
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    29.458,
                                                    41.858
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 6",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            237.001,
                                            294.892
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            29.458,
                                            41.891
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 6",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.19,
                                                            0
                                                        ],
                                                        [
                                                            0.069,
                                                            0.023
                                                        ],
                                                        [
                                                            0,
                                                            0.271
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.352
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.273,
                                                            -0.219
                                                        ],
                                                        [
                                                            0.221,
                                                            -0.274
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.071,
                                                            0
                                                        ],
                                                        [
                                                            -0.256,
                                                            -0.09
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.352
                                                        ],
                                                        [
                                                            0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.219,
                                                            -0.278
                                                        ],
                                                        [
                                                            0.275,
                                                            0.22
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.122,
                                                            0.155
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            -5.538,
                                                            9.457
                                                        ],
                                                        [
                                                            -5.749,
                                                            9.422
                                                        ],
                                                        [
                                                            -6.176,
                                                            8.82
                                                        ],
                                                        [
                                                            -6.176,
                                                            -8.82
                                                        ],
                                                        [
                                                            -5.538,
                                                            -9.457
                                                        ],
                                                        [
                                                            -4.9,
                                                            -8.82
                                                        ],
                                                        [
                                                            -4.9,
                                                            7
                                                        ],
                                                        [
                                                            4.96,
                                                            -5.357
                                                        ],
                                                        [
                                                            5.855,
                                                            -5.459
                                                        ],
                                                        [
                                                            5.955,
                                                            -4.564
                                                        ],
                                                        [
                                                            -5.041,
                                                            9.217
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    41.06,
                                                    26.676
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 7",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            290.828,
                                            224.056
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            41.019,
                                            26.676
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 7",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.286,
                                                            0
                                                        ],
                                                        [
                                                            -3.213,
                                                            3.42
                                                        ],
                                                        [
                                                            -0.808,
                                                            1.789
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            5.47,
                                                            4.819
                                                        ],
                                                        [
                                                            5.064,
                                                            0
                                                        ],
                                                        [
                                                            1.327,
                                                            -1.412
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            -7.61,
                                                            -8.821
                                                        ],
                                                        [
                                                            -19.52,
                                                            4.108
                                                        ],
                                                        [
                                                            -7.61,
                                                            8.821
                                                        ],
                                                        [
                                                            5.219,
                                                            3.256
                                                        ],
                                                        [
                                                            8.459,
                                                            -1.571
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0.572549045086,
                                                    0.819607853889,
                                                    0.945098042488,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 8')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    43.132,
                                                    44.317
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 9",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            300.665,
                                            306.187
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            43.132,
                                            44.317
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 9",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 5,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            2.15,
                                                            2.92
                                                        ],
                                                        [
                                                            1.216,
                                                            0.971
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.923,
                                                            -1.254
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            2.338,
                                                            -9.692
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            5.395,
                                                            -3.537
                                                        ],
                                                        [
                                                            2.175,
                                                            -6.891
                                                        ],
                                                        [
                                                            -8.821,
                                                            6.891
                                                        ],
                                                        [
                                                            7.8,
                                                            14.14
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0.572549045086,
                                                    0.819607913494,
                                                    0.945098102093,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 9')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    44.342,
                                                    28.606
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 10",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            306.298,
                                            233.039
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            44.342,
                                            28.606
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 110",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 6,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -4.649
                                                        ],
                                                        [
                                                            -0.833,
                                                            -2.045
                                                        ],
                                                        [
                                                            -1.813,
                                                            -1.719
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -15.243,
                                                            1.25
                                                        ],
                                                        [
                                                            0,
                                                            2.343
                                                        ],
                                                        [
                                                            0.958,
                                                            2.349
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            8.763,
                                                            -17.987
                                                        ],
                                                        [
                                                            -8.82,
                                                            -0.386
                                                        ],
                                                        [
                                                            -7.512,
                                                            6.229
                                                        ],
                                                        [
                                                            -3.307,
                                                            12.403
                                                        ],
                                                        [
                                                            8.82,
                                                            -0.386
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0.572549045086,
                                                    0.819607853889,
                                                    0.945098042488,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 10')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    26.702,
                                                    35.883
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 12",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            224.168,
                                            266.922
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            26.702,
                                            35.883
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 112",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 7,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            1.365,
                                                            0.246
                                                        ],
                                                        [
                                                            1.054,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -1.002,
                                                            -0.18
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -3.077,
                                                            -1.998
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            -0.42,
                                                            -8.528
                                                        ],
                                                        [
                                                            -3.501,
                                                            -8.821
                                                        ],
                                                        [
                                                            -3.501,
                                                            8.821
                                                        ],
                                                        [
                                                            7.528,
                                                            -5.156
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0.572549045086,
                                                    0.819607913494,
                                                    0.945098102093,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 11')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    39.022,
                                                    26.676
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 14",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            281.531,
                                            224.056
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            39.022,
                                            26.676
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 114",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 8,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    385.695,
                                    214.264
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    265.233,
                                    265.12
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 45,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 1 :M",
                    "np": 8,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 28 :M",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 34,
                            "s": [
                                45
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 64,
                            "s": [
                                -10
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 114,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 138,
                            "s": [
                                48
                            ]
                        },
                        {
                            "t": 149.000006068894,
                            "s": [
                                45
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 0,
                            "s": [
                                386.853,
                                385.103,
                                0
                            ],
                            "to": [
                                0,
                                2.311,
                                0
                            ],
                            "ti": [
                                0,
                                2.166,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 24,
                            "s": [
                                386.853,
                                398.968,
                                0
                            ],
                            "to": [
                                0,
                                -2.166,
                                0
                            ],
                            "ti": [
                                0,
                                2.311,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 44,
                            "s": [
                                386.853,
                                372.105,
                                0
                            ],
                            "to": [
                                0,
                                -2.311,
                                0
                            ],
                            "ti": [
                                0,
                                -2.166,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 0.51
                            },
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "t": 64,
                            "s": [
                                386.853,
                                385.103,
                                0
                            ],
                            "to": [
                                0,
                                0,
                                0
                            ],
                            "ti": [
                                0,
                                0,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 80,
                            "s": [
                                386.853,
                                385.103,
                                0
                            ],
                            "to": [
                                0,
                                2.311,
                                0
                            ],
                            "ti": [
                                0,
                                2.166,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 104,
                            "s": [
                                386.853,
                                398.968,
                                0
                            ],
                            "to": [
                                0,
                                -2.166,
                                0
                            ],
                            "ti": [
                                0,
                                2.311,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.51,
                                "y": 1
                            },
                            "o": {
                                "x": 0.49,
                                "y": 0
                            },
                            "t": 124,
                            "s": [
                                386.853,
                                372.105,
                                0
                            ],
                            "to": [
                                0,
                                -2.311,
                                0
                            ],
                            "ti": [
                                0,
                                -2.166,
                                0
                            ]
                        },
                        {
                            "t": 144.00000586524,
                            "s": [
                                386.853,
                                385.103,
                                0
                            ]
                        }
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        386.853,
                        385.103,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 14,
                            "s": [
                                90,
                                90,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 34,
                            "s": [
                                110,
                                110,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 94,
                            "s": [
                                90,
                                90,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 114,
                            "s": [
                                110,
                                110,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.51,
                                    0.51,
                                    0.51
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.49,
                                    0.49,
                                    0.49
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 134,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "t": 149.000006068894,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.246,
                                                    3.412
                                                ],
                                                [
                                                    1.256,
                                                    3.412
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.946,
                                                    0.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.647
                                                ],
                                                [
                                                    0.459,
                                                    0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.945,
                                                    0.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.459,
                                                    -0.458
                                                ],
                                                [
                                                    0,
                                                    -0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.346,
                                                    2.251
                                                ],
                                                [
                                                    -2.635,
                                                    2.963
                                                ],
                                                [
                                                    0.796,
                                                    2.963
                                                ],
                                                [
                                                    2.961,
                                                    0.796
                                                ],
                                                [
                                                    3.673,
                                                    -0.919
                                                ],
                                                [
                                                    2.961,
                                                    -2.635
                                                ],
                                                [
                                                    2.25,
                                                    -3.346
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 2,
                                    "ty": "sh",
                                    "ix": 3,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.721,
                                                    0.722
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.988
                                                ],
                                                [
                                                    0.698,
                                                    -0.698
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.947,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.698,
                                                    0.698
                                                ],
                                                [
                                                    0,
                                                    0.987
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.722,
                                                    0.722
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.92,
                                                    4.945
                                                ],
                                                [
                                                    -3.536,
                                                    3.863
                                                ],
                                                [
                                                    -4.697,
                                                    2.701
                                                ],
                                                [
                                                    -4.697,
                                                    1.801
                                                ],
                                                [
                                                    1.8,
                                                    -4.696
                                                ],
                                                [
                                                    2.701,
                                                    -4.696
                                                ],
                                                [
                                                    3.863,
                                                    -3.535
                                                ],
                                                [
                                                    4.946,
                                                    -0.919
                                                ],
                                                [
                                                    3.863,
                                                    1.697
                                                ],
                                                [
                                                    1.697,
                                                    3.863
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 3",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.304,
                                            59.301
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 28",
                            "np": 5,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    376.102,
                                    376.092
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    59.335,
                                    59.332
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 228",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -1.196,
                                                    1.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.196,
                                                    1.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.196,
                                                    -1.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.196,
                                                    1.196
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.066,
                                                    3.231
                                                ],
                                                [
                                                    3.231,
                                                    1.065
                                                ],
                                                [
                                                    3.231,
                                                    -3.266
                                                ],
                                                [
                                                    2.07,
                                                    -4.427
                                                ],
                                                [
                                                    -4.428,
                                                    2.069
                                                ],
                                                [
                                                    -3.266,
                                                    3.231
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.835294187069,
                                            0.309803932905,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.485,
                                            59.482
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 29",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    376.102,
                                    376.097
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    59.335,
                                    59.333
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 229",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.169,
                                                    0
                                                ],
                                                [
                                                    0.119,
                                                    0.12
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    0.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.248,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.249,
                                                    -0.248
                                                ],
                                                [
                                                    0.248,
                                                    0.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.248
                                                ],
                                                [
                                                    0.249,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.17,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.249,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.249,
                                                    0.248
                                                ],
                                                [
                                                    -0.249,
                                                    0.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    -0.248
                                                ],
                                                [
                                                    0.249,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.119,
                                                    0.12
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.388,
                                                    7.552
                                                ],
                                                [
                                                    -0.063,
                                                    7.365
                                                ],
                                                [
                                                    -7.335,
                                                    0.094
                                                ],
                                                [
                                                    -7.335,
                                                    -0.807
                                                ],
                                                [
                                                    -0.839,
                                                    -7.304
                                                ],
                                                [
                                                    0.063,
                                                    -7.304
                                                ],
                                                [
                                                    4.55,
                                                    -2.818
                                                ],
                                                [
                                                    4.55,
                                                    -1.918
                                                ],
                                                [
                                                    3.649,
                                                    -1.918
                                                ],
                                                [
                                                    -0.387,
                                                    -5.953
                                                ],
                                                [
                                                    -5.984,
                                                    -0.357
                                                ],
                                                [
                                                    0.388,
                                                    6.014
                                                ],
                                                [
                                                    6.434,
                                                    -0.033
                                                ],
                                                [
                                                    7.335,
                                                    -0.033
                                                ],
                                                [
                                                    7.335,
                                                    0.867
                                                ],
                                                [
                                                    0.838,
                                                    7.365
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            54.67,
                                            54.637
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 30",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    354.382,
                                    354.378
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    54.67,
                                    54.668
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 330",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.08,
                                                    5.191
                                                ],
                                                [
                                                    5.191,
                                                    2.081
                                                ],
                                                [
                                                    -2.08,
                                                    -5.191
                                                ],
                                                [
                                                    -5.191,
                                                    -2.079
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.572549045086,
                                            0.819607913494,
                                            0.945098102093,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 12')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            54.403,
                                            54.934
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 31",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    353.138,
                                    355.617
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    54.403,
                                    54.934
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 331",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.367,
                                                    5.904
                                                ],
                                                [
                                                    5.904,
                                                    1.368
                                                ],
                                                [
                                                    -1.367,
                                                    -5.904
                                                ],
                                                [
                                                    -5.904,
                                                    -1.367
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.69,
                                            55.646
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 32",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    349.819,
                                    358.935
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    53.69,
                                    55.646
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 332",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.387,
                                                    6.884
                                                ],
                                                [
                                                    6.884,
                                                    0.388
                                                ],
                                                [
                                                    -0.387,
                                                    -6.884
                                                ],
                                                [
                                                    -6.884,
                                                    -0.387
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.133333340287,
                                            0.61960786581,
                                            0.796078503132,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 13')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            54.67,
                                            54.667
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 33",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    354.382,
                                    354.375
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    54.67,
                                    54.667
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 333",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 34 :M",
            "parent": 3,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        331.465,
                        331.462,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        331.465,
                        331.462,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.569,
                                                    -0.031
                                                ],
                                                [
                                                    0.061,
                                                    3.6
                                                ],
                                                [
                                                    3.572,
                                                    0.091
                                                ],
                                                [
                                                    -0.06,
                                                    -3.539
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.163,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.163,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.249,
                                                    -0.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.249,
                                                    -0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    0.125
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.061,
                                                    5.139
                                                ],
                                                [
                                                    -0.389,
                                                    4.952
                                                ],
                                                [
                                                    -4.922,
                                                    0.421
                                                ],
                                                [
                                                    -4.922,
                                                    -0.479
                                                ],
                                                [
                                                    -0.51,
                                                    -4.889
                                                ],
                                                [
                                                    0.391,
                                                    -4.889
                                                ],
                                                [
                                                    4.922,
                                                    -0.358
                                                ],
                                                [
                                                    4.922,
                                                    0.542
                                                ],
                                                [
                                                    0.512,
                                                    4.952
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            49.748,
                                            49.714
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 34",
                            "np": 4,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    331.465,
                                    331.462
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    49.748,
                                    49.746
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 334",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.061,
                                                    4.471
                                                ],
                                                [
                                                    4.471,
                                                    0.061
                                                ],
                                                [
                                                    -0.061,
                                                    -4.471
                                                ],
                                                [
                                                    -4.471,
                                                    -0.061
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.835294127464,
                                            0.309803932905,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 11')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            49.748,
                                            49.745
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 35",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    331.466,
                                    331.461
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    49.748,
                                    49.745
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 335",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 36 :M",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        375.481,
                        215.218,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        375.481,
                        215.218,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.735,
                                                    -0.001
                                                ],
                                                [
                                                    0.001,
                                                    0.734
                                                ],
                                                [
                                                    -0.735,
                                                    -0.001
                                                ],
                                                [
                                                    0.001,
                                                    -0.734
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            61.652,
                                            26.126
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 36",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    386.889,
                                    221.494
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    61.652,
                                    26.126
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 94,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 108,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 128.000005213547,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 336",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -0.405
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.405
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.735,
                                                    -0.001
                                                ],
                                                [
                                                    0.001,
                                                    0.735
                                                ],
                                                [
                                                    -0.735,
                                                    -0.001
                                                ],
                                                [
                                                    0.001,
                                                    -0.735
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            61.652,
                                            31.027
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 37",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    386.889,
                                    244.311
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    61.652,
                                    31.027
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 92,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 106,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 126.000005132085,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 337",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    -0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.735,
                                                    0.001
                                                ],
                                                [
                                                    0.001,
                                                    0.735
                                                ],
                                                [
                                                    -0.735,
                                                    0.001
                                                ],
                                                [
                                                    0.001,
                                                    -0.735
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            61.652,
                                            34.946
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 38",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    386.889,
                                    262.561
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    61.652,
                                    34.946
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 90,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 104,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 124.000005050624,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 338",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ],
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            0,
                                                            2.596
                                                        ],
                                                        [
                                                            -0.637,
                                                            1.96
                                                        ],
                                                        [
                                                            -0.637,
                                                            -1.96
                                                        ],
                                                        [
                                                            0,
                                                            -2.596
                                                        ],
                                                        [
                                                            0.637,
                                                            -1.96
                                                        ],
                                                        [
                                                            0.637,
                                                            1.96
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    61.652,
                                                    40.828
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 39",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            386.89,
                                            289.942
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            61.652,
                                            40.828
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 339",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.353
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.353
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            1.96,
                                                            0.637
                                                        ],
                                                        [
                                                            -1.96,
                                                            0.637
                                                        ],
                                                        [
                                                            -2.598,
                                                            -0.001
                                                        ],
                                                        [
                                                            -1.96,
                                                            -0.637
                                                        ],
                                                        [
                                                            1.96,
                                                            -0.637
                                                        ],
                                                        [
                                                            2.598,
                                                            -0.001
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    61.652,
                                                    40.828
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 40",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            386.887,
                                            289.944
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            61.652,
                                            40.828
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 440",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    386.887,
                                    289.942
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    386.887,
                                    289.942
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 88,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 102,
                                        "s": [
                                            100,
                                            100
                                        ]
                                    },
                                    {
                                        "t": 122.000004969162,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 39 :M",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.735,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    -0.734
                                                ],
                                                [
                                                    0.735,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    0.734
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            56.752,
                                            28.331
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 41",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    364.075,
                                    231.76
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    56.752,
                                    28.331
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 88,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 102,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 122.000004969162,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 441",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.735,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    -0.734
                                                ],
                                                [
                                                    0.735,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    0.734
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            56.752,
                                            22.45
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 42",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    364.075,
                                    204.38
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    56.752,
                                    22.45
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 86,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 100,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 120.0000048877,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 442",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.406
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.735,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    -0.734
                                                ],
                                                [
                                                    0.735,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    0.734
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            56.752,
                                            17.549
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 43",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    364.075,
                                    181.56
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    56.752,
                                    17.549
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 84,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 98,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 118.000004806239,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 443",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.406
                                                ],
                                                [
                                                    0.407,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    -0.405,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.735,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    -0.735
                                                ],
                                                [
                                                    0.735,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    0.735
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            56.752,
                                            14.609
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 44",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    364.075,
                                    167.872
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    56.752,
                                    14.609
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 82,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 96,
                                        "s": [
                                            465.576,
                                            465.576
                                        ]
                                    },
                                    {
                                        "t": 116.000004724777,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 444",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.351
                                                        ],
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            0,
                                                            2.596
                                                        ],
                                                        [
                                                            -0.637,
                                                            1.96
                                                        ],
                                                        [
                                                            -0.637,
                                                            -1.96
                                                        ],
                                                        [
                                                            0,
                                                            -2.596
                                                        ],
                                                        [
                                                            0.637,
                                                            -1.96
                                                        ],
                                                        [
                                                            0.637,
                                                            1.96
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    56.752,
                                                    8.728
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 45",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            364.074,
                                            140.493
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            56.752,
                                            8.728
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 445",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.352
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -0.352,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            -0.352
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0.353,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0.352
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            1.96,
                                                            0.637
                                                        ],
                                                        [
                                                            -1.96,
                                                            0.637
                                                        ],
                                                        [
                                                            -2.598,
                                                            0
                                                        ],
                                                        [
                                                            -1.96,
                                                            -0.637
                                                        ],
                                                        [
                                                            1.96,
                                                            -0.637
                                                        ],
                                                        [
                                                            2.598,
                                                            0
                                                        ]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0.282352954149,
                                                    0.549019634724,
                                                    1
                                                ],
                                                "ix": 4,
                                                "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 5
                                            },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    56.751,
                                                    8.729
                                                ],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ],
                                                "ix": 3
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 6
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100,
                                                "ix": 7
                                            },
                                            "sk": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 4
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0,
                                                "ix": 5
                                            },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 46",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            364.072,
                                            140.496
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            56.751,
                                            8.729
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            465.576,
                                            465.576
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Layer 12 Outlines - Group 446",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    364.072,
                                    140.493
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    364.072,
                                    140.493
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 80,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.51,
                                                0.51
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.49,
                                                0.49
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 94,
                                        "s": [
                                            100,
                                            100
                                        ]
                                    },
                                    {
                                        "t": 114.000004643315,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 45 :M",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 9,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 16 :M",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        145.056,
                        352.676,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        145.056,
                        352.676,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 15,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 27,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 45,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 65,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 95,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 107,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 125,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "t": 145.000005905971,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.54
                                                ],
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ],
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -2.794
                                                ],
                                                [
                                                    -2.793,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.793
                                                ],
                                                [
                                                    2.793,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.242
                                                ],
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.243
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.243
                                                ],
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.242
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    4.067
                                                ],
                                                [
                                                    -4.067,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.067
                                                ],
                                                [
                                                    4.067,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            54.302
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 16",
                            "np": 4,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.056,
                                    352.676
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    54.302
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 116",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.894
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.894
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.253,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -2.253,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.572549045086,
                                            0.819607853889,
                                            0.945098042488,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 10')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.531,
                                            54.302
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 22",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    139.572,
                                    352.675
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    8.531,
                                    54.302
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 222",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.894
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.894
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.43,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -3.43,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.133333340287,
                                            0.61960786581,
                                            0.796078443527,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 6')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            54.302
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 23",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.054,
                                    352.675
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    54.302
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 223",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 17 :M",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        145.056,
                        297.916,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        145.056,
                        297.916,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 12,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 24,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 42,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 62,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 92,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 104,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 122,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "t": 142.000005783779,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.539
                                                ],
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.541
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.541
                                                ],
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.539
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -2.794
                                                ],
                                                [
                                                    -2.793,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    2.793
                                                ],
                                                [
                                                    2.793,
                                                    -0.001
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.243
                                                ],
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ],
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.243
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    4.067
                                                ],
                                                [
                                                    -4.067,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -4.067
                                                ],
                                                [
                                                    4.067,
                                                    -0.001
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            42.54
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 17",
                            "np": 4,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.056,
                                    297.916
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    42.54
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 117",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.253,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -2.253,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.572549045086,
                                            0.819607853889,
                                            0.945098042488,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 8')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.531,
                                            42.54
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 24",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    139.572,
                                    297.913
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    8.531,
                                    42.54
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 224",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.43,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -3.43,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.137254908681,
                                            0.61960786581,
                                            0.796078443527,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 4')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            42.54
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 25",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.054,
                                    297.913
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    42.54
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 225",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 21 :M",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        145.056,
                        243.156,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        145.056,
                        243.156,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 9,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 21,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 39,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 59,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 89,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 101,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 119,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "t": 139.000005661586,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.54
                                                ],
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ],
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -2.793
                                                ],
                                                [
                                                    -2.793,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.794
                                                ],
                                                [
                                                    2.793,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.243
                                                ],
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ],
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.243
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    4.067
                                                ],
                                                [
                                                    -4.067,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.067
                                                ],
                                                [
                                                    4.067,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            30.779
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 21",
                            "np": 4,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.056,
                                    243.156
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    30.779
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 221",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.253,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -2.253,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.882353007793,
                                            0.447058856487,
                                            0.447058856487,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 9')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.531,
                                            30.779
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 26",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    139.572,
                                    243.156
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    8.531,
                                    30.779
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 226",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.43,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -3.43,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.772549033165,
                                            0.266666680574,
                                            0.266666680574,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 5')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            30.779
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 27",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.054,
                                    243.156
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    30.779
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 227",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 18 :M",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        145.056,
                        188.403,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        145.056,
                        188.403,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 6,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 18,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 36,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 56,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 86,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 98,
                            "s": [
                                70,
                                70,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 116,
                            "s": [
                                115,
                                115,
                                100
                            ]
                        },
                        {
                            "t": 136.000005539394,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.539
                                                ],
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.54
                                                ],
                                                [
                                                    1.54,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.539
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -2.794
                                                ],
                                                [
                                                    -2.793,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.793
                                                ],
                                                [
                                                    2.793,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.242
                                                ],
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.242
                                                ],
                                                [
                                                    2.242,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.242
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    4.066
                                                ],
                                                [
                                                    -4.067,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.066
                                                ],
                                                [
                                                    4.067,
                                                    0
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "mm",
                                    "mm": 1,
                                    "nm": "Merge Paths 1",
                                    "mn": "ADBE Vector Filter - Merge",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 2",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            19.018
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 18",
                            "np": 5,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.056,
                                    188.403
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    19.018
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 118",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.244,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.244,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.253,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -2.253,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.882352948189,
                                            0.447058826685,
                                            0.447058826685,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 11')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.531,
                                            19.018
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 19",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    139.572,
                                    188.403
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    8.531,
                                    19.018
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 119",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    1.895
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.895
                                                ],
                                                [
                                                    1.895,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.43,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    3.431
                                                ],
                                                [
                                                    -3.43,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -3.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.772549033165,
                                            0.266666680574,
                                            0.266666680574,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 7')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.709,
                                            19.018
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 20",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    145.054,
                                    188.403
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    9.709,
                                    19.018
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 220",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 47 :M",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        286.481,
                        124.521,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        280.198,
                        157.581,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        110.112,
                        110.112,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.264,
                                                    0
                                                ],
                                                [
                                                    0.059,
                                                    0.01
                                                ],
                                                [
                                                    0.059,
                                                    0.019
                                                ],
                                                [
                                                    0.049,
                                                    0.029
                                                ],
                                                [
                                                    0.04,
                                                    0.049
                                                ],
                                                [
                                                    0,
                                                    0.264
                                                ],
                                                [
                                                    -0.049,
                                                    0.128
                                                ],
                                                [
                                                    -0.097,
                                                    0.088
                                                ],
                                                [
                                                    -0.06,
                                                    0.039
                                                ],
                                                [
                                                    -0.059,
                                                    0.029
                                                ],
                                                [
                                                    -0.068,
                                                    0.019
                                                ],
                                                [
                                                    -0.225,
                                                    -0.234
                                                ],
                                                [
                                                    -0.049,
                                                    -0.117
                                                ],
                                                [
                                                    0,
                                                    -0.128
                                                ],
                                                [
                                                    0.186,
                                                    -0.178
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.06,
                                                    0
                                                ],
                                                [
                                                    -0.068,
                                                    -0.019
                                                ],
                                                [
                                                    -0.059,
                                                    -0.03
                                                ],
                                                [
                                                    -0.06,
                                                    -0.039
                                                ],
                                                [
                                                    -0.186,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    -0.128
                                                ],
                                                [
                                                    0.048,
                                                    -0.117
                                                ],
                                                [
                                                    0.04,
                                                    -0.049
                                                ],
                                                [
                                                    0.049,
                                                    -0.029
                                                ],
                                                [
                                                    0.059,
                                                    -0.019
                                                ],
                                                [
                                                    0.324,
                                                    -0.06
                                                ],
                                                [
                                                    0.088,
                                                    0.088
                                                ],
                                                [
                                                    0.049,
                                                    0.128
                                                ],
                                                [
                                                    0,
                                                    0.264
                                                ],
                                                [
                                                    -0.186,
                                                    0.185
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    0.999
                                                ],
                                                [
                                                    -0.186,
                                                    0.99
                                                ],
                                                [
                                                    -0.372,
                                                    0.932
                                                ],
                                                [
                                                    -0.538,
                                                    0.844
                                                ],
                                                [
                                                    -0.686,
                                                    0.717
                                                ],
                                                [
                                                    -0.979,
                                                    0.021
                                                ],
                                                [
                                                    -0.901,
                                                    -0.354
                                                ],
                                                [
                                                    -0.686,
                                                    -0.666
                                                ],
                                                [
                                                    -0.538,
                                                    -0.794
                                                ],
                                                [
                                                    -0.372,
                                                    -0.881
                                                ],
                                                [
                                                    -0.186,
                                                    -0.939
                                                ],
                                                [
                                                    0.695,
                                                    -0.666
                                                ],
                                                [
                                                    0.911,
                                                    -0.354
                                                ],
                                                [
                                                    0.979,
                                                    0.021
                                                ],
                                                [
                                                    0.695,
                                                    0.717
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.986,
                                            5.272
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 47",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    300.918,
                                    157.566
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    44.986,
                                    5.294
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 32,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 52,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.167,
                                                0.167
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 72,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 110,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 130,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "t": 150.000006109625,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 447",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0.54
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.549
                                                ],
                                                [
                                                    0.548,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.549
                                                ],
                                                [
                                                    0.548,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.54
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.98,
                                                    0.008
                                                ],
                                                [
                                                    0,
                                                    -0.979
                                                ],
                                                [
                                                    0.98,
                                                    0.008
                                                ],
                                                [
                                                    0,
                                                    0.979
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            40.086,
                                            5.293
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 48",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    280.198,
                                    157.561
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    40.086,
                                    5.293
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 28,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 48,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.167,
                                                0.167
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 68,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 107,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 127,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "t": 147.000005987433,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 448",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.068,
                                                    0
                                                ],
                                                [
                                                    0.059,
                                                    0.01
                                                ],
                                                [
                                                    0.058,
                                                    0.019
                                                ],
                                                [
                                                    0.049,
                                                    0.029
                                                ],
                                                [
                                                    0.04,
                                                    0.049
                                                ],
                                                [
                                                    0.048,
                                                    0.117
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    -0.049,
                                                    0.128
                                                ],
                                                [
                                                    -0.097,
                                                    0.088
                                                ],
                                                [
                                                    -0.06,
                                                    0.039
                                                ],
                                                [
                                                    -0.06,
                                                    0.03
                                                ],
                                                [
                                                    -0.068,
                                                    0.01
                                                ],
                                                [
                                                    -0.128,
                                                    -0.029
                                                ],
                                                [
                                                    -0.059,
                                                    -0.019
                                                ],
                                                [
                                                    -0.058,
                                                    -0.029
                                                ],
                                                [
                                                    -0.049,
                                                    -0.049
                                                ],
                                                [
                                                    -0.049,
                                                    -0.117
                                                ],
                                                [
                                                    0,
                                                    -0.128
                                                ],
                                                [
                                                    0.049,
                                                    -0.118
                                                ],
                                                [
                                                    0.088,
                                                    -0.09
                                                ],
                                                [
                                                    0.049,
                                                    -0.039
                                                ],
                                                [
                                                    0.059,
                                                    -0.029
                                                ],
                                                [
                                                    0.058,
                                                    -0.019
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.06,
                                                    0
                                                ],
                                                [
                                                    -0.068,
                                                    -0.019
                                                ],
                                                [
                                                    -0.06,
                                                    -0.029
                                                ],
                                                [
                                                    -0.06,
                                                    -0.039
                                                ],
                                                [
                                                    -0.097,
                                                    -0.09
                                                ],
                                                [
                                                    -0.049,
                                                    -0.118
                                                ],
                                                [
                                                    0,
                                                    -0.128
                                                ],
                                                [
                                                    0.048,
                                                    -0.117
                                                ],
                                                [
                                                    0.04,
                                                    -0.049
                                                ],
                                                [
                                                    0.049,
                                                    -0.029
                                                ],
                                                [
                                                    0.058,
                                                    -0.019
                                                ],
                                                [
                                                    0.127,
                                                    -0.029
                                                ],
                                                [
                                                    0.058,
                                                    0.01
                                                ],
                                                [
                                                    0.059,
                                                    0.03
                                                ],
                                                [
                                                    0.049,
                                                    0.039
                                                ],
                                                [
                                                    0.088,
                                                    0.088
                                                ],
                                                [
                                                    0.049,
                                                    0.128
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    -0.049,
                                                    0.117
                                                ],
                                                [
                                                    -0.049,
                                                    0.049
                                                ],
                                                [
                                                    -0.058,
                                                    0.029
                                                ],
                                                [
                                                    -0.059,
                                                    0.019
                                                ],
                                                [
                                                    -0.069,
                                                    0.01
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    0.984
                                                ],
                                                [
                                                    -0.186,
                                                    0.965
                                                ],
                                                [
                                                    -0.371,
                                                    0.907
                                                ],
                                                [
                                                    -0.538,
                                                    0.819
                                                ],
                                                [
                                                    -0.686,
                                                    0.691
                                                ],
                                                [
                                                    -0.9,
                                                    0.378
                                                ],
                                                [
                                                    -0.979,
                                                    -0.004
                                                ],
                                                [
                                                    -0.9,
                                                    -0.378
                                                ],
                                                [
                                                    -0.686,
                                                    -0.691
                                                ],
                                                [
                                                    -0.538,
                                                    -0.818
                                                ],
                                                [
                                                    -0.371,
                                                    -0.906
                                                ],
                                                [
                                                    -0.186,
                                                    -0.955
                                                ],
                                                [
                                                    0.197,
                                                    -0.955
                                                ],
                                                [
                                                    0.383,
                                                    -0.906
                                                ],
                                                [
                                                    0.548,
                                                    -0.818
                                                ],
                                                [
                                                    0.695,
                                                    -0.691
                                                ],
                                                [
                                                    0.911,
                                                    -0.378
                                                ],
                                                [
                                                    0.979,
                                                    -0.004
                                                ],
                                                [
                                                    0.911,
                                                    0.378
                                                ],
                                                [
                                                    0.695,
                                                    0.691
                                                ],
                                                [
                                                    0.548,
                                                    0.819
                                                ],
                                                [
                                                    0.383,
                                                    0.907
                                                ],
                                                [
                                                    0.197,
                                                    0.965
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.185,
                                            5.297
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 49",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    259.478,
                                    157.595
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    35.185,
                                    5.301
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 24,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 44,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 64,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 104,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.55,
                                                0.55
                                            ],
                                            "y": [
                                                1,
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.45,
                                                0.45
                                            ],
                                            "y": [
                                                0,
                                                0
                                            ]
                                        },
                                        "t": 124,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "t": 144.00000586524,
                                        "s": [
                                            422.82,
                                            422.82
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 449",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "Layer 12 Outlines - Group 50 :M",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 0,
                            "s": [
                                218.057,
                                250,
                                0
                            ],
                            "to": [
                                0,
                                4.188,
                                0
                            ],
                            "ti": [
                                0,
                                3.611,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 24,
                            "s": [
                                218.057,
                                275.13,
                                0
                            ],
                            "to": [
                                0,
                                -3.611,
                                0
                            ],
                            "ti": [
                                0,
                                4.188,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 44,
                            "s": [
                                218.057,
                                228.336,
                                0
                            ],
                            "to": [
                                0,
                                -4.188,
                                0
                            ],
                            "ti": [
                                0,
                                -3.611,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 0.55
                            },
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "t": 64,
                            "s": [
                                218.057,
                                250,
                                0
                            ],
                            "to": [
                                0,
                                0,
                                0
                            ],
                            "ti": [
                                0,
                                0,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 80,
                            "s": [
                                218.057,
                                250,
                                0
                            ],
                            "to": [
                                0,
                                4.188,
                                0
                            ],
                            "ti": [
                                0,
                                3.611,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 104,
                            "s": [
                                218.057,
                                275.13,
                                0
                            ],
                            "to": [
                                0,
                                -3.611,
                                0
                            ],
                            "ti": [
                                0,
                                4.188,
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": 0.55,
                                "y": 1
                            },
                            "o": {
                                "x": 0.45,
                                "y": 0
                            },
                            "t": 124,
                            "s": [
                                218.057,
                                228.336,
                                0
                            ],
                            "to": [
                                0,
                                -4.188,
                                0
                            ],
                            "ti": [
                                0,
                                -3.611,
                                0
                            ]
                        },
                        {
                            "t": 144.00000586524,
                            "s": [
                                218.057,
                                250,
                                0
                            ]
                        }
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        218.057,
                        250,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 14,
                            "s": [
                                90,
                                90,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 34,
                            "s": [
                                110,
                                110,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 94,
                            "s": [
                                90,
                                90,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.55,
                                    0.55,
                                    0.55
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.45,
                                    0.45,
                                    0.45
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 114,
                            "s": [
                                110,
                                110,
                                100
                            ]
                        },
                        {
                            "t": 134.000005457932,
                            "s": [
                                100,
                                100,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.892,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    0.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.189,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.891
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.891
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.891,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    24.501,
                                                    5.047
                                                ],
                                                [
                                                    -24.501,
                                                    5.047
                                                ],
                                                [
                                                    -25.139,
                                                    4.41
                                                ],
                                                [
                                                    -25.139,
                                                    -3.43
                                                ],
                                                [
                                                    -23.521,
                                                    -5.047
                                                ],
                                                [
                                                    -13.229,
                                                    -5.047
                                                ],
                                                [
                                                    -12.593,
                                                    -4.41
                                                ],
                                                [
                                                    -13.229,
                                                    -3.773
                                                ],
                                                [
                                                    -23.521,
                                                    -3.773
                                                ],
                                                [
                                                    -23.864,
                                                    -3.43
                                                ],
                                                [
                                                    -23.864,
                                                    3.774
                                                ],
                                                [
                                                    23.864,
                                                    3.774
                                                ],
                                                [
                                                    23.864,
                                                    -3.43
                                                ],
                                                [
                                                    23.522,
                                                    -3.773
                                                ],
                                                [
                                                    -9.31,
                                                    -3.773
                                                ],
                                                [
                                                    -9.947,
                                                    -4.41
                                                ],
                                                [
                                                    -9.31,
                                                    -5.047
                                                ],
                                                [
                                                    23.522,
                                                    -5.047
                                                ],
                                                [
                                                    25.139,
                                                    -3.43
                                                ],
                                                [
                                                    25.139,
                                                    4.41
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.389,
                                            5.297
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 50",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    218.057,
                                    124.52
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    25.389,
                                    5.297
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 550",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.553,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.071,
                                                    -4.41
                                                ],
                                                [
                                                    -20.071,
                                                    -4.41
                                                ],
                                                [
                                                    -21.071,
                                                    -3.41
                                                ],
                                                [
                                                    -21.071,
                                                    4.41
                                                ],
                                                [
                                                    21.071,
                                                    4.41
                                                ],
                                                [
                                                    21.071,
                                                    -3.41
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.572549045086,
                                            0.819607853889,
                                            0.945098042488,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 8')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            24.899,
                                            5.297
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 51",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    215.776,
                                    124.52
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    24.899,
                                    5.297
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 551",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.553,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.553,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.541,
                                                    -4.41
                                                ],
                                                [
                                                    -21.541,
                                                    -4.41
                                                ],
                                                [
                                                    -22.541,
                                                    -3.41
                                                ],
                                                [
                                                    -22.541,
                                                    4.41
                                                ],
                                                [
                                                    22.541,
                                                    4.41
                                                ],
                                                [
                                                    22.541,
                                                    -3.41
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            23.429,
                                            5.297
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 52",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    208.932,
                                    124.52
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    23.429,
                                    5.297
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 552",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.552,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.553
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.502,
                                                    -4.41
                                                ],
                                                [
                                                    -23.502,
                                                    -4.41
                                                ],
                                                [
                                                    -24.502,
                                                    -3.41
                                                ],
                                                [
                                                    -24.502,
                                                    4.41
                                                ],
                                                [
                                                    24.502,
                                                    4.41
                                                ],
                                                [
                                                    24.502,
                                                    -3.41
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.137254908681,
                                            0.61960786581,
                                            0.796078443527,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 4')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.389,
                                            5.297
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 53",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    218.059,
                                    124.52
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    25.389,
                                    5.297
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 553",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.892,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.891
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.189,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.892,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.189,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.891
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.522,
                                                    19.322
                                                ],
                                                [
                                                    -23.521,
                                                    19.322
                                                ],
                                                [
                                                    -25.138,
                                                    17.706
                                                ],
                                                [
                                                    -25.138,
                                                    8.886
                                                ],
                                                [
                                                    -24.5,
                                                    8.249
                                                ],
                                                [
                                                    -23.865,
                                                    8.886
                                                ],
                                                [
                                                    -23.865,
                                                    17.706
                                                ],
                                                [
                                                    -23.521,
                                                    18.049
                                                ],
                                                [
                                                    23.522,
                                                    18.049
                                                ],
                                                [
                                                    23.865,
                                                    17.706
                                                ],
                                                [
                                                    23.865,
                                                    -18.686
                                                ],
                                                [
                                                    24.5,
                                                    -19.322
                                                ],
                                                [
                                                    25.138,
                                                    -18.686
                                                ],
                                                [
                                                    25.138,
                                                    17.706
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.389,
                                            44.925
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 54",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    218.057,
                                    309.017
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    25.389,
                                    44.925
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 554",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.351
                                                ],
                                                [
                                                    0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    3.07
                                                ],
                                                [
                                                    -0.637,
                                                    2.434
                                                ],
                                                [
                                                    -0.637,
                                                    -2.434
                                                ],
                                                [
                                                    0.001,
                                                    -3.07
                                                ],
                                                [
                                                    0.637,
                                                    -2.434
                                                ],
                                                [
                                                    0.637,
                                                    2.434
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0.888,
                                            47.457
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 55",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    103.984,
                                    320.807
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0.888,
                                    47.457
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 555",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.501,
                                                    16.335
                                                ],
                                                [
                                                    -25.139,
                                                    15.698
                                                ],
                                                [
                                                    -25.139,
                                                    -15.697
                                                ],
                                                [
                                                    -24.501,
                                                    -16.335
                                                ],
                                                [
                                                    24.501,
                                                    -16.335
                                                ],
                                                [
                                                    25.139,
                                                    -15.697
                                                ],
                                                [
                                                    25.139,
                                                    -5.046
                                                ],
                                                [
                                                    24.501,
                                                    -4.409
                                                ],
                                                [
                                                    23.864,
                                                    -5.046
                                                ],
                                                [
                                                    23.864,
                                                    -15.061
                                                ],
                                                [
                                                    -23.864,
                                                    -15.061
                                                ],
                                                [
                                                    -23.864,
                                                    15.698
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.282352954149,
                                            0.549019634724,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.389,
                                            25.406
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 56",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    218.057,
                                    218.14
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    25.389,
                                    25.406
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 556",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.553
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.553
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.553,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.031,
                                                    -26.951
                                                ],
                                                [
                                                    23.031,
                                                    -26.951
                                                ],
                                                [
                                                    23.031,
                                                    25.951
                                                ],
                                                [
                                                    22.031,
                                                    26.951
                                                ],
                                                [
                                                    -22.031,
                                                    26.951
                                                ],
                                                [
                                                    -23.031,
                                                    25.951
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.835294187069,
                                            0.309803932905,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            26.86,
                                            36.658
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 57",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    224.905,
                                    270.53
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    26.86,
                                    36.658
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 557",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.552,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.553
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.553
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.501,
                                                    -26.951
                                                ],
                                                [
                                                    24.501,
                                                    -26.951
                                                ],
                                                [
                                                    24.501,
                                                    25.951
                                                ],
                                                [
                                                    23.501,
                                                    26.951
                                                ],
                                                [
                                                    -23.501,
                                                    26.951
                                                ],
                                                [
                                                    -24.501,
                                                    25.951
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 4,
                                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            25.39,
                                            36.658
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 58",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    218.059,
                                    270.53
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    25.39,
                                    36.658
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    465.576,
                                    465.576
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Layer 12 Outlines - Group 558",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 9,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}